import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';
import React from 'react';

const Footer = () => {
  const { formatMessage } = useIntl();
  return (
    <DefaultFooter
      style={{ background: 'none', padding: '4px' }}
      copyright={formatMessage({ id: 'footer.copyright' })}
      links={[
        {
          key: 'usage',
          title: formatMessage({ id: 'footer.links.usage' }),
          href: '/policy/usage',
        },
        {
          key: 'privacy',
          title: formatMessage({ id: 'footer.links.privacy' }),
          href: '/policy/privacy',
        },
      ]}
    />
  );
};

export default Footer;
